module.exports = __webpack_public_path__ + "static/img/wallpaper-mb1.f24398a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wallpaper-mb1.jpg
// module id = Wpyj
// module chunks = 1